import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { peformanceRequestListRequest, peformanceNewReviewRequest, peformanceNewReviewRequestStatus } from '../../../redux/performance/peformance.action'
import moment from "moment";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ReactStars from "react-rating-stars-component";

const PerformanceRequestList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { performanceRequestListSuccess, performanceRequestListError,
        newPerformanceReviewSuccess, newPerformanceReviewError, newPerformanceReviewReqStatus
    } = useSelector(state => state.peformance)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const REQUEST_LIST = [
        { key: APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.PENDING) },
        { key: APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.COMPLETED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.COMPLETED) },
        { key: 'REQUEST_RECEIVED', value: removeSpecialCharAndChangeToPascal('REQUEST_RECEIVED') },
    ]

    const [selectedStatus, setSelectedStatus] = useState(REQUEST_LIST[0])
    const [selectedRequest, setSelectedRequest] = useState(null)
    const [rating, setRating] = useState('')
    const [feedback, setFeedback] = useState('')
    const [showFeedbackModal, setShowFeedbackModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REQUEST_LIST, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchRequestList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            data.businessId = selectedBusiness.businessId
            data.locationId = selectedLocation.locationId
        }
        if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        if (selectedStatus.key !== 'REQUEST_RECEIVED') {
            data.status = selectedStatus.key
        }
        if (selectedStatus.key === 'REQUEST_RECEIVED') {
            data.reviewerId = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.reviewerUserType = user.data.userDetails.userType
        } else {
            data.employeeId = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.employeeUserType = user.data.userDetails.userType
        }
        dispatch(peformanceRequestListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (newPerformanceReviewReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(newPerformanceReviewSuccess.data?.message)
            setSelectedRequest(null)
            setRating('')
            setFeedback('')
            fetchRequestList()
        } else if (newPerformanceReviewReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newPerformanceReviewError.message)
        }
        if (newPerformanceReviewReqStatus?.length) {
            dispatch(peformanceNewReviewRequestStatus(''))
        }
    }, [newPerformanceReviewSuccess, newPerformanceReviewError, newPerformanceReviewReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REQUEST_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_REQUEST_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(performanceRequestListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(performanceRequestListError)) {
            setLoading(false)
        }
    }, [performanceRequestListSuccess, performanceRequestListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchRequestList()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (!isEmpty(selectedStatus)) {
            fetchRequestList()
        }
    }, [selectedStatus])

    const handleCreateRequestClick = () => {
        navigate(ROUTES.performance.newRequest)
    }

    const getStatusClassName = (e, selectedStatus) => {
        if (e.key === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.PENDING) {
            if (selectedStatus.key === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.PENDING) {
                return 'tl-status-item tl-status-item-selected-blue'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.COMPLETED) {
            if (selectedStatus.key === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.COMPLETED) {
                return 'tl-status-item tl-status-item-selected-green'
            } else {
                return 'tl-status-item'
            }
        } else {
            if (selectedStatus.key === 'REQUEST_RECEIVED') {
                return 'tl-status-item tl-status-item-selected-dark-green'
            } else {
                return 'tl-status-item'
            }
        }
    }

    const handleRequestDetailClick = (item) => {
        setSelectedRequest(item)
        setShowFeedbackModal(true)
    }

    const handleReviewSubmitClick = () => {
        if (isEmpty(selectedRequest)) {
            displayErrorToast('Request not selected. Please try again.')
        } else if (isEmpty(rating)) {
            displayErrorToast('Rating not selected')
        } else if (isEmpty(feedback)) {
            displayErrorToast('Feedback cannot be blank')
        } else {
            setLoading(true)
            const data = {
                employeeId: selectedRequest.employeeId,
                employeeUserType: selectedRequest.employeeUserType,
                businessId: selectedRequest.businessId,
                locationId: selectedRequest.locationId,
                reviewerId: selectedRequest.reviewerId,
                reviewYear: selectedRequest.reviewYear,
                reviewerUserType: selectedRequest.reviewerUserType,
                rating: parseFloat(rating),
                feedback: feedback,
                performanceRequestId: selectedRequest.performanceRequestId
            }
            dispatch(peformanceNewReviewRequest(data))
            setShowFeedbackModal(false)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Requests' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="tl-status-row-container">
                    {!isEmpty(REQUEST_LIST) && <div className="tl-status-parent-container">
                        <div className="tl-status-container">
                            {REQUEST_LIST.map(e => (
                                <div className={getStatusClassName(e, selectedStatus)} onClick={() => setSelectedStatus(e)}>{e.value}</div>
                            ))}
                        </div>
                    </div>}
                </div>
                {!isEmpty(selectedStatus) && !isNull(performanceRequestListSuccess) && !isEmpty(performanceRequestListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Review Year</th>
                                {!isEmpty(selectedStatus) && selectedStatus.key !== 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Reviewer</th>}
                                {!isEmpty(selectedStatus) && selectedStatus.key !== 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Employee Code</th>}
                                {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Employee</th>}
                                {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Employee Code</th>}
                                <th scope="col" className="text-center">Date</th>
                                {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Status</th>}
                                {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <th scope="col" className="text-center">Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {performanceRequestListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.reviewYear}</td>
                                    {!isEmpty(selectedStatus) && selectedStatus.key !== 'REQUEST_RECEIVED' && <td className="text-center">{!isEmpty(element.reviewerDetails) ? `${element.reviewerDetails.firstName} ${element.reviewerDetails.lastName}` : 'N/A'}</td>}
                                    {!isEmpty(selectedStatus) && selectedStatus.key !== 'REQUEST_RECEIVED' && <td className="text-center">{element.reviewerDetails?.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? !isEmpty(element.reviewerDetails?.employeeBusinessMapping[0].employeeCode) ? element.reviewerDetails?.employeeBusinessMapping[0].employeeCode : '-' : removeSpecialCharAndChangeToPascal(element.reviewerDetails.userType)}</td>}
                                    {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <td className="text-center">{!isEmpty(element.employeeDetails) ? `${element.employeeDetails.firstName} ${element.employeeDetails.lastName}` : 'N/A'}</td>}
                                    {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <td className="text-center">{element.employeeDetails?.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? !isEmpty(element.employeeDetails?.employeeBusinessMapping[0].employeeCode) ? element.employeeDetails?.employeeBusinessMapping[0].employeeCode : '-' : removeSpecialCharAndChangeToPascal(element.employeeDetails.userType)}</td>}
                                    <td className="text-center">{moment.utc(element.createdOn).local().format('DD/MM/YYYY')}</td>
                                    {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <td className="text-center">{removeSpecialCharAndChangeToPascal(element.status)}</td>}
                                    {!isEmpty(selectedStatus) && selectedStatus.key === 'REQUEST_RECEIVED' && <td className="text-center">
                                        <div className="loc-list-button-container">
                                            {element.status === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.PENDING && <div className="loc-list-button" onClick={() => { handleRequestDetailClick(element) }}><div className="tr-action-btn">Submit Feedback</div></div>}
                                            {element.status === APP_CONSTANTS.PERFORMANCE_REQUEST_STATUS.COMPLETED && <div className="loc-list-button" ><div className="prl-completed-btn">COMPLETED</div></div>}
                                        </div>
                                    </td>}
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(performanceRequestListError) && <div className="content-error">{performanceRequestListError.message}</div>}
                {!isEmpty(selectedStatus) && selectedStatus.key !== 'REQUEST_RECEIVED' && <div className="vl-fab-container" onClick={() => handleCreateRequestClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowFeedbackModal(false) }}
                show={showFeedbackModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Submit Feedback
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="prl-feedback-container">
                        <div className="prl-rating-container">
                            <ReactStars
                                count={5} // Number of stars
                                value={rating} // Initial rating
                                size={50} // Size of stars
                                activeColor="#ffd700" // Star color
                                isHalf={true} // Allow half-stars
                                onChange={e => setRating(e)} // Callback function
                            />
                        </div>
                        <CommonInputFloatFull
                            type='text'
                            id='feedback'
                            onChange={e => setFeedback(e.target.value)}
                            placeholder='Enter Feedback'
                            value={feedback}
                            multiline={true}
                            rows={5}
                        />
                        {/* <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{newPeformanceRequestSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to request another feedback?</div>

                    </div> */}
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { setShowFeedbackModal(false) }}>CANCEL</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleReviewSubmitClick() }}>SUBMIT</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PerformanceRequestList